;(function (pyatt, $, window, document, undefined) {

    // Make sure global app namespace is available
    //window.pyatt = pyatt || {};

    /*
     * Set general variables
     */
    var $window = $(window),
        winsize,
        mobileWidth = 625; //not exact match to css media query, but close enough

    /*
     * Helper Functions
     */
    //Get window height and width and set in variable object
    function getWinSize() {
        winsize = {width: $window.width(), height: $window.height()};
    }
    //get initial window size
    getWinSize();
    //get new winSize on resize
    $window.on('resize', Foundation.utils.throttle(function (e) {
        getWinSize();
    }, 300));

    //Check if mobile window width size
    function isMobileWidth() {
        return ( winsize.width < mobileWidth );
    }


    pyatt.featuredSlider = {

        /**
         * Init feature slider
         *
         */
        init : function() {

            var owlFeatured = $("#owl-featured");

            owlFeatured.owlCarousel({

                // Most important owl features
                items: 1,
                itemsCustom: false,
                itemsDesktop: [1199, 1],
                itemsDesktopSmall: [980, 1],
                itemsTablet: [768, 1],
                itemsTabletSmall: [300, 1],
                itemsMobile: [479, 1],
                singleItem: false,
                itemsScaleUp: false,

                //Basic Speeds
                slideSpeed: 100,
                paginationSpeed: 800,
                rewindSpeed: 1000,

                //Autoplay
                autoPlay: false,
                stopOnHover: false,

                // Navigation
                navigation: false,
                navigationText: ["prev", "next"],
                rewindNav: true,
                scrollPerPage: false,

                //Pagination
                pagination: false,
                paginationNumbers: false,

                // Responsive
                responsive: true,
                responsiveRefreshRate: 100,
                responsiveBaseWidth: window,

                // CSS Styles
                baseClass: "owl-carousel",
                theme: "owl-theme",

                //Lazy load
                lazyLoad: true,
                lazyFollow: true,
                lazyEffect: "fade",

                //Auto height
                autoHeight: true,

                //JSON
                jsonPath: false,
                jsonSuccess: false,

                //Mouse Events
                dragBeforeAnimFinish: true,
                mouseDrag: true,
                touchDrag: true,

                //Transitions
                transitionStyle: "fade",

                // Other
                addClassActive: true,

                //Callbacks
                beforeUpdate: false,
                afterUpdate: function () {
                },
                beforeInit: false,
                beforeInit : function(elem){
                    //Parameter elem pointing to $("#owl-demo")
                    pyatt.featuredSlider.randomSlide(elem);
                },
                afterInit: false,
                beforeMove: false,
                afterMove: false,
                afterAction: false,
                startDragging: false,
                afterLazyLoad: false

            });
        },

        randomSlide : function (owlSelector) {
            owlSelector.children().sort(function(){
                return Math.round(Math.random()) - 0.5;
            }).each(function(){
              $(this).appendTo(owlSelector);
            });
        }

    };

}(window.pyatt = window.pyatt || {}, jQuery, window, window.document));